import React from "react";
import { Modal, Form, Input, Button } from "antd";

const AuditBackDateReasonForm = (props) => {
  const { open, setVisible, onCreate } = props;
  const [form] = Form.useForm();

  const handleCreate = () => {
    form
      .validateFields()
      .then((values) => {
        onCreate(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };
  const handleCancel = () => {
  setVisible(false);
};
  return (
    // <Modal
    //   open={open}
    //   title="Backdate Reason"
    //   okText="Submit"
    //   onCancel={() => {
    //     setVisible(false);
    //   }}
    //   onOk={handleCreate}
    //   width={450}
    //   className="reasonModal"
    // >
    //   <Form form={form} layout="">
    //     <Form.Item
    //       label={
    //         <>
    //           <span className="auditBackDateReason-label">
    //             Provide reason for Backdate entry
    //           </span>
    //         </>
    //       }
    //       name="auditBackDateReason"
    //       rules={[{ required: true, message: "Please input the reason!" }]}
    //       labelAlign="left"
    //       className="auditBackDateReason"
    //     >
    //       <Input.TextArea rows={2} />
    //     </Form.Item>
    //   </Form>
    // </Modal>

    <Modal
  open={open}
  title="Backdate Reason"
  onCancel={handleCancel}
  width={450}
  className="reasonModal"
  footer={
    <div className="modalBtns">
      <Button
        className="defaultBtn defaultGreyBtn"
        onClick={handleCancel}
      >
        Cancel
      </Button>

      <Button
        type="primary"
        className="defaultBtn"
        onClick={handleCreate}
      >
        Submit
      </Button>
    </div>
  }
>
  <Form className="pb-16" form={form}>
    <Form.Item
      label={
        <span className="auditBackDateReason-label">
          Provide reason for Backdate entry
        </span>
      }
      name="auditBackDateReason"
      rules={[{ required: true, message: "Please input the reason!" }]}
      labelCol={{ span: 24 }}
  wrapperCol={{ span: 24 }}
      labelAlign="left"
      className="auditBackDateReason"
    >
      <Input.TextArea rows={2} />
    </Form.Item>
  </Form>
</Modal>
  );
};

export default AuditBackDateReasonForm;
